export const FORM_TYPE = {
    REFINEMENT: 'REFINEMENT',
    ADMIN_UPLOAD_PRESCRIPTION_NOTES: 'ADMIN_UPLOAD_PRESCRIPTION_NOTES',
};

/**
 * @typedef {Object} PrescriptionFormOption
 * @property {string} value - The option value
 * @property {string} label - The display label for the option
 * @property {PrescriptionFormOption[]} [options] - Optional nested sub-options
 */

export const PrescriptionFormOption = {};

/**
 * @typedef {Object} RestorativeQuestion
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 * @property {PrescriptionFormOption[]} options - Array of available options
 * @property {VerticalDimension} verticalDimension
 */

export const RestorativeQuestion = {};

/**
 * @typedef {Object} VerticalDimensionOption
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 */

export const VerticalDimensionOption = {};

/**
 * @typedef {Object} VerticalDimensionQuestion
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 * @property {VerticalDimensionOption[]} options - Array of available options
 */

/**
 * @typedef {Object} VerticalDimension
 * @property {VerticalDimensionQuestion} verticalDimensionUpperPosterior - The question of vertical dimension increase
 * @property {VerticalDimensionQuestion} verticalDimensionLowerPosterior - The question of vertical dimension increase
 */

export const VerticalDimension = {};

/**
 * @typedef {Object} RestorativeOptionDeliveryQuestion
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 * @property {VerticalDimensionOption[]} options - Array of available options
 */

/**
 * @typedef {Object} RestorativeSubValue
 * @property {string} value - The sub-option value (e.g., 'flowableInjection', 'compositeOnlay', or empty string)
 * @property {Array<string|number>} onlayPosition - Array of selected tooth positions for onlay placement
 * @property {VerticalDimension} verticalDimension - Vertical dimension configuration options
 */

export const RestorativeSubValue = {};

/**
 * @typedef {Object} RestorativeOptions
 * @property {string} value - Main restorative option selection ('Yes' or 'No')
 * @property {RestorativeSubValue} subValue - Sub-options configuration when main value is 'Yes'
 */

export const RestorativeOptions = {};

/**
 * @typedef {Object} PreImplantAligmentQuestion
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 * @property {PrescriptionFormOption[]} options - Array of available options
 */

export const PreImplantAligmentQuestion = {};

/**
 * @typedef {Object} PreImplantAligment
 * @property {string} value - The question value identifier
 * @property {string|number[]} prostheticSpace - Array of available options
 */

export const PreImplantAligment = {};

/**
 * @typedef {Object} AddOnSmileDesignQuestion
 * @property {string} value - The question value identifier
 * @property {string} label - The display label for the question
 * @property {PrescriptionFormOption[]} options - Array of available options
 */

export const AddOnSmileDesignQuestion = {};
